export const PrimaryButton = ({ onClick, children }) => (
  <button
    onClick={onClick}
    className="px-4 py-3 bg-primary text-white text-sm font-semibold rounded"
  >
    {children}
  </button>
);
